import { RouterPages } from 'shared/model/routes'

import { ReactNode, useEffect } from 'react'

import { Navigate } from 'react-router-dom'

import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useGetMeMutation } from 'modules/Auth/services/authApi'

import { ContentLoader } from 'shared/ui/ContentLoader'

import {
  useAppDispatch,
  useAppSelector,
} from 'shared/config/redux/hooks/useRedux'
import { setCurrentVersion } from 'shared/config/redux/slices/auth'

interface AuthProviderProps {
  children: ReactNode
}

export default function AuthProvider({ children }: AuthProviderProps) {
  const dispatch = useAppDispatch()

  const [getMe, { isLoading, isError }] = useGetMeMutation()

  const { handleLogout } = useAuth()
  const { currentVersion } = useAppSelector((state) => state.auth)

  const handleCheckVersion = async () => {
    const newVersion = import.meta.env.VITE_NAVAT_CRM_VERSION

    if (currentVersion === null) {
      dispatch(setCurrentVersion(newVersion))
    } else if (currentVersion !== newVersion) {
      await handleLogout()
    }
  }

  useEffect(() => {
    handleCheckVersion()
    getMe()
  }, [])

  if (isLoading) {
    return <ContentLoader />
  }

  if (isError) {
    return <Navigate to={RouterPages.login} />
  }

  return <div>{children}</div>
}
